export default __webpack_public_path__ + "static/media/circleUpload.bbb025d1.svg";